import styled from '@emotion/styled';

export const SwitchWrapper = styled.div``;

export const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 70px;
  height: 40px;
  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  input:checked + span {
    //background-color: #fafafa;
  }

  input:checked + span:before {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
    background-color: #7fe200;
  }

  input:checked + span:after {
    background-color: rgba(127, 226, 0, 0.5);
  }
`;

export const SwitchSlider = styled.span`
  border-radius: 34px;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  //background-color: #fafafa;
  //border: 1px solid rgba(224, 224, 224, 0.5);
  -webkit-transition: 0.4s;
  transition: 0.4s;

  &:before {
    border-radius: 50%;
    position: absolute;
    content: '';
    height: 24px;
    width: 24px;
    left: 16px;
    bottom: 7px;
    background-color: #999999;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  &:after {
    position: absolute;
    content: '';
    width: 39px;
    height: 15px;
    left: 16px;
    bottom: 11.5px;
    border-radius: 20px;
    background: rgba(153, 153, 153, 0.3);
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
`;
